import React from "react";
import Box from "@mui/material/Box";
import Header from "../../component/Header";
import Footer from "../../component/Footer";
import Sidebar from "../../component/Sidebar";
import { useAuth } from "../../context/auth";
import BreadcrumbsComponent from "./breadcrumb/BreadcrumbsComponent";

export default function AuthLayout({ children }) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return null;
  }

  return (
    <React.Fragment>
      <Box className="main_layout">
        <Box className="layout_inner">
          <Header />

          <Box className="page_with_sidebar">
            <Box
              className="sidebar_main"
              sx={{ display: { md: "block", xs: "none" } }}
            >
              <Sidebar />
            </Box>
            <Box className="main-wrapper">
              <BreadcrumbsComponent />
              <Box component="main" className="pages_main">
                {children}
              </Box>
            </Box>
          </Box>

          <Footer />
        </Box>
      </Box>
    </React.Fragment>
  );
}
